import React, { useEffect, useState } from "react";
import { Image, Nav, Offcanvas, ToastContainer } from "react-bootstrap";
import Link from "next/link";
import { useRouter } from "next/router";
import { useToasts } from "@/hooks/toasts";
import { useAuth } from "@/hooks/auth";
import ToastMessage from "@/components/ToastMessage";
import { Loading } from "@/components/Loading";
import { useAppSelector } from "@/lib/redux/store";
import { useSelector } from "react-redux";

const ResellersLayout = ({ children }) =>
{
  const { toasts, removeToast } = useToasts();
  const { logout } = useAuth();
  const router = useRouter();
  const store = useAppSelector((state) => state.app);
  const { roleActingAs, user } = store;
  const persist = useSelector((state) => state._persist);
  const [isLoading, setIsLoading] = useState(true);
  const [showSidebar, setShowSidebar] = useState(false);
  const handleSidebarClose = () => setShowSidebar(false);
  const handleSidebarShow = () => setShowSidebar(true);
  const handleLogout = () => logout();

  const sidebarLinks = [
    { label: "Home", href: "/resellers/dashboard", icon: "bi bi-house-door" },
    { label: "Customers", href: "/resellers/customers", basePath: "/resellers/customers", icon: "bi bi-receipt" },
    {
      label: "Sales Analysis",
      href: "/resellers/sales-analysis",
      basePath: "/resellers/sales-analysis",
      icon: "bi bi-graph-up"
    },
    { label: 'Questions Template', href: `/reseller-poll-templates`, icon: 'bi bi-patch-question' },
    {
      label: "Reports",
      href: "/resellers/view-resellers-reports",
      icon: "bi bi-file-earmark-text"
    },
    { label: "FAQ's", href: "/resellers/faq", icon: "bi bi-question-circle" },
    { label: "Security", href: "/resellers/security", icon: "bi bi-shield-lock" },
    {
      label: "My Account",
      href: `/resellers/view-resellers-details/${roleActingAs?.reseller?.id}`,
      basePath: "/resellers/view-resellers-details",
      icon: "bi bi-person",
    },
    { label: "Reseller Tutorial", href: "/resellers/tutorial", icon: "bi bi-play-btn" },
    { label: "Customer Tutorial", href: "/resellers/customer-tutorial", icon: "bi bi-play-btn" },
    { label: "Help Center", href: "/resellers/support", icon: "bi bi-question-circle" },
    { label: "Logout", href: "#", icon: "bi bi-box-arrow-right", onClick: handleLogout },
  ];

  useEffect(() =>
  {
    if (!persist?.rehydrated) return;

    if (!user)
    {
      router.push('/login');
      return;
    }

    setIsLoading(false);
  }, [persist?.rehydrated, router, user]);

  if (isLoading)
  {
    return <Loading loading={isLoading} />;
  }

  return (
    <div className="backend">
      <section className="d-flex position-relative">
        {/*   Mobile Navbar with Toggle */}
        <nav className="navbar navbar-light bg-light d-lg-none px-3 w-100">
          <button
            className="reseller-toggle-btn"
            type="button"
            onClick={handleSidebarShow}
          >
            <i className="bi bi-list fs-2"></i>
          </button>
          <Link className="navbar-brand ms-2 mobileResponse" href="/resellers/dashboard">
            <Image
              src="/images/instant-polls-logo.jpg"
              alt="Instant Polls Logo"
              height={40}
              className="adminNavImg"
            />
          </Link>
        </nav>

        {/*   Sidebar */}
        <Offcanvas
          show={showSidebar}
          onHide={handleSidebarClose}
          responsive="lg"
          className="sticky-lg-top p-3 bg-white"
          
        >
          <Offcanvas.Body
            className="d-flex flex-column cavasBody"
            
          >
            <Link className="navbar-brand" href="/resellers/dashboard">
              <Image
                src="/images/instant-polls-logo.jpg"
                alt="Instant Polls Logo"
                className="adminNavImg"
              />
            </Link>

            <p className="text-center text-primary border-2 rounded">
              <strong className="d-block p-1 secondaryColor">{user?.name}</strong>
              <span className=" secondaryColor">
                {roleActingAs?.role?.name}
              </span>
            </p>

            <Nav className="nav-pills flex-column mb-auto">
              {sidebarLinks.map((link, index) =>
              {
                const matchPath = link.basePath || link.href;
                const isActive =
                  router.asPath === link.href ||
                  router.asPath.startsWith(matchPath + "/") ||
                  router.asPath === matchPath;

                return (
                  <Nav.Item key={index}>
                    {link.label === "Logout" ? (
                      <a
                        href="#"
                        className="nav-link p-1"
                        onClick={link.onClick}
                      >
                        <i className={link.icon}></i>
                        <span className="ms-3 nav-text">{link.label}</span>
                      </a>
                    ) : (
                      <Link
                        href={link.href}
                        className={`nav-link p-1 ${isActive ? "Reselleractive" : ""}`}
                        onClick={handleSidebarClose}
                      >
                        <i className={link.icon}></i>
                        <span className="ms-3 nav-text">{link.label}</span>
                      </Link>
                    )}
                  </Nav.Item>
                );
              })}
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
        <div id="content" className="flex-grow-1">
          <div className="container-fluid p-3 p-lg-4">{children}</div>
          <ToastContainer
            position="top-end"
            className="p-3 z-index-top"
            
          >
            {toasts.map((toast, i) => (
              <ToastMessage
                key={i}
                onClose={() => removeToast(toast.id)}
                message={toast.message}
                variant={toast.variant}
              />
            ))}
          </ToastContainer>
        </div>
      </section>
    </div>
  );
};

export default ResellersLayout;